import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Result, Spin } from 'antd';
import BackendApiClient from '../../../services/api/BackendApiClient';
import GoogleBusinessManager from '../../../services/api/google-business/GoogleBusinessManager';
import {
  GoogleBusinessOAuthStatus,
  completeGoogleBusinessOAuth,
} from '../../../services/google-business/GoogleBusinessOAuth';

/**
 * Where Google sends every manager after Google Business consent, on the neutral host
 * whichever dashboard they started from. Rendered on its own, outside the dashboard
 * shell: the manager usually has no session on this host, and nothing here may carry
 * a brand. The single-use `state` in the query is all Shop needs.
 */
export default function GoogleBusinessOAuthCallbackView() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Views:Marketing:GoogleBusiness.callback' });

  const [status, setStatus] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    // StrictMode runs this twice in development; the state can only be spent once.
    if (started.current) {
      return;
    }

    started.current = true;
    const { search, pathname } = window.location;
    // The code is single use, but it has no business staying in the history either.
    window.history.replaceState(null, '', pathname);

    const manager = new GoogleBusinessManager(
      new BackendApiClient(
        axios.create({
          baseURL: import.meta.env.VITE_API_BASE_URL,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        }),
      ),
    );

    completeGoogleBusinessOAuth({ search, opener: window.opener, complete: manager.completeOAuth }).then((result) => {
      setStatus(result.status);

      if (result.reported) {
        window.close();
      }
    });
  }, []);

  function renderResult() {
    switch (status) {
      case GoogleBusinessOAuthStatus.Connected:
        return <Result status="success" title={t('connected')} />;
      case GoogleBusinessOAuthStatus.Cancelled:
        return <Result status="info" title={t('cancelled')} />;
      default:
        return <Result status="error" title={t('failed')} />;
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-white">
      {status === null ? (
        <div className="flex flex-col items-center gap-4">
          <Spin size="large" />
          <p>{t('connecting')}</p>
        </div>
      ) : (
        renderResult()
      )}
    </div>
  );
}
